import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicPeopleEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic-people-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/people/embed',
	query: [],
};
